import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import Select from "react-select";
import { ProgressBar } from "react-loader-spinner";

import { Button, Form } from "react-bootstrap";

import { fetchWithToken } from "../../../../interceptors/fetchInterceptor";

import NotificationWindow from "../../../../components/GeneralComponents/NotificationWindow/NotificationWindow";
import EditableTableForKnoweledgeTest from "../../../../components/knowledgeTestComponents/commonComponents/EditableTableForKnoweledgeTest/EditableTableForKnoweledgeTest";
import ResultModalWindow from "../../../../components/AdministrativeProcedures/commonComponents/ResultModalWindow/ResultModalWindow";

import {
  columnsKnoweledgeTestRecordTable,
  optionsInputsKnoweledgeTestRecord,
  setOptionsKnoweledgeTestRecord,
  customStyles,
  customErrorStyles,
} from "./optionsForKnoweledgeTestRecord";

import {
  SET_DATA_FOR_EDIT_KNOWELEDGE_TEST_RECORD,
  UPDATE_EDITABLE_TABLE_DATA_KNOWELEDGE_TEST_RECORD,
  UPDATE_INPUT_DATA_KNOWELEDGE_TEST_RECORD,
  UPDATE_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD,
} from "../../../../redux/types";

import {
  API_GET_DATA_FOR_EDIT_KNOWELEDGE_TEST_RECORD,
  API_PRINT_PROTOCOL_FOR_PEOPLE_KNOWELEDGE_TEST_RECORD,
  API_SAVE_EDIT_KNOWELEDGE_TEST_RECORD,
  API_SAVE_KNOWELEDGE_TEST_RECORD,
  MAIN_URL,
  PORT_FOR_TRAINING,
} from "../../../../constants/constants";

import add_icon from "../../../../resourсes/add-icon.svg";

import styles from "./cardKnowledgeTestRecord.module.css";

function CardKnowledgeTestRecord() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { mode, protocolNum, additionalAccess } = location.state || {};

  const [showNotificationWindow, setShowNotificationWindow] = useState(false);
  const [messageNotificationWindow, setMessageNotificationWindow] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showResultModal, setShowResultModal] = useState(false);
  const [registrationResult, setRegistrationResult] = useState("");
  const [appId, setAppId] = useState(null);
  const [saveKey, setSaveKey] = useState(false);
  const [errorsFields, setErrorsFields] = useState(
    Object.entries({ ...optionsInputsKnoweledgeTestRecord })
      .filter((item) => item[1].required)
      .map((el) => el[0]),
  );
  const [dateError, setDateError] = useState("");
  const knowledgeTestRecordState = useSelector((state) => {
    const { knowledgeTestRecordReducer } = state;
    return knowledgeTestRecordReducer;
  });
  const dataOptionsForSelectProgramId = [];
  const dictionaryState = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });
  dictionaryState.trainingProgramLibrary.forEach((item) => {
    dataOptionsForSelectProgramId.push({
      value: item.id,
      label: item.sign,
      key: "programId",
    });
  });

  setOptionsKnoweledgeTestRecord(
    dataOptionsForSelectProgramId,
    optionsInputsKnoweledgeTestRecord.programId.key,
  );
  const updateInputData = async (e) => {
    if (e.target) {
      dispatch({
        type: UPDATE_INPUT_DATA_KNOWELEDGE_TEST_RECORD,
        data: { [`${e.target.id}`]: e.target.value },
      });
      if (e.target.id === "protDate") {
        if (new Date(e.target.value) > new Date()) {
          setErrors({ [`${e.target.id}`]: "Дата протокола не может быть больше текущей даты" });
          setDateError("Дата протокола не может быть больше текущей даты");
        } else {
          const newErrors = { ...errors };
          delete newErrors[`${e.target.id}`];
          setErrors(newErrors);
          setDateError("");
        }
        dispatch({
          type: UPDATE_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD,
          data: { [`${e.target.id}`]: e.target.value },
        });
      }
    } else {
      const selectedData = {
        [`${e.key}`]: e.value,
      };
      if (e.value == 1 && e.key === optionsInputsKnoweledgeTestRecord.examType.key) {
        selectedData.examTypeName = "Теоретический экзамен";
        setOptionsKnoweledgeTestRecord(true, columnsKnoweledgeTestRecordTable.ticketNum.accessor);
      }
      if (e.value == 2 && e.key === optionsInputsKnoweledgeTestRecord.examType.key) {
        selectedData.examTypeName = "Практический экзамен";
        setOptionsKnoweledgeTestRecord(false, columnsKnoweledgeTestRecordTable.ticketNum.accessor);
      }

      dispatch({
        type: UPDATE_INPUT_DATA_KNOWELEDGE_TEST_RECORD,
        data: selectedData,
      });
      dispatch({
        type: UPDATE_SEARCH_PARAMS_KNOWELEDGE_TEST_RECORD,
        data: { [`${e.key}`]: e.value },
      });
    }
  };

  const handleButtonAddListener = (e) => {
    e.preventDefault();
    navigate("/knoweledge-test-record/add/searchPeople");
  };

  const handleTableDataUpdate = (newData) => {
    dispatch({
      type: UPDATE_EDITABLE_TABLE_DATA_KNOWELEDGE_TEST_RECORD,
      data: newData,
    });
  };
  const handleErrors = () => {
    let newErrors = {};
    errorsFields.forEach((elem) => {
      if (
        !knowledgeTestRecordState.dataMain[elem] ||
        knowledgeTestRecordState.dataMain[elem] === "" ||
        knowledgeTestRecordState.dataMain[elem] === null
      ) {
        newErrors[elem] = "Заполните поле";
      }
    });
    if (knowledgeTestRecordState.dataMain.examType === 1) {
      knowledgeTestRecordState.dataForTable.forEach((el) => {
        if (el.passedId === "3" || el.passedId === "4") {
          el.error = false;
          return;
        }
        if (!Boolean(el.ticketNum) || !Boolean(el.passed)) {
          el.error = true;
        } else {
          el.error = false;
        }
      });
      if (knowledgeTestRecordState.dataForTable.find((el) => el.error === true)) {
        newErrors.errorsTable = "Заполните поле";
      }
    }
    if (new Date(knowledgeTestRecordState.searchParamsForPeople.protDate) > new Date()) {
      setDateError("Дата протокола не может быть больше текущей даты");
      newErrors.protDate = "Дата протокола не может быть больше текущей даты";
    }

    if (Object.keys(newErrors).length > 0 || dateError) {
      setErrors(newErrors);
      return true;
    } else {
      setErrors({});
      return false;
    }
  };
  const handleSave = async () => {
    if (!handleErrors()) {
      const dataForJSON = knowledgeTestRecordState.dataForTable.map((el) => {
        el.programId = knowledgeTestRecordState.dataMain.programId;
        el.protDate = knowledgeTestRecordState.dataMain.protDate;
        el.protNum = knowledgeTestRecordState.dataMain.protNum;
        el.examType = knowledgeTestRecordState.dataMain.examType;
        return el;
      });
      const json = JSON.stringify(dataForJSON);
      let response = null;
      if (mode === "add") {
        response = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_SAVE_KNOWELEDGE_TEST_RECORD, {
          method: "POST",
          body: json,
        });
      } else {
        response = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_SAVE_EDIT_KNOWELEDGE_TEST_RECORD, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: knowledgeTestRecordState.dataForTable[0].id,
            e2PassNameString: knowledgeTestRecordState.dataForTable[0].passedId
              ? knowledgeTestRecordState.dataForTable[0].passedId
              : "",
          }),
        });
      }

      if (response.status !== 200) {
        const responseData = await response.text();
        setMessageNotificationWindow(responseData);
        setShowNotificationWindow(!showNotificationWindow);
      } else {
        const responseText = await response.text();
        setAppId(responseText);
        setShowResultModal(!showResultModal);
        setRegistrationResult("success");
      }
    } else {
      setSaveKey(true);
    }
  };
  const handlePrint = () => {
    async function print() {
      await fetchWithToken(
        MAIN_URL +
          PORT_FOR_TRAINING +
          API_PRINT_PROTOCOL_FOR_PEOPLE_KNOWELEDGE_TEST_RECORD +
          `?section=1&ids=${knowledgeTestRecordState.dataForTable.reduce(
            (acc, current) => (Boolean(acc) ? acc + "," + current.checkId : current.checkId),
            "",
          )}&protNum=${knowledgeTestRecordState.dataMain.protNum}&protDate=${
            knowledgeTestRecordState.dataMain.protDate
          }`,
      )
        .then((response) => response.blob())
        .then((blob) => {
          const fileName = `Протокол №${knowledgeTestRecordState.dataMain.protNum}.doc`;
          const blobUrl = URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = blobUrl;
          downloadLink.download = fileName;

          downloadLink.click();
        })
        .catch((error) => {
          console.error("Ошибка при получении PDF-документа:", error);
        });
    }
    print();
  };
  const handleCloseApp = () => {
    navigate(-1);
  };
  useEffect(() => {
    async function fetchData() {
      const response = await fetchWithToken(
        MAIN_URL +
          PORT_FOR_TRAINING +
          API_GET_DATA_FOR_EDIT_KNOWELEDGE_TEST_RECORD +
          "?protNumAndExamType=" +
          String(protocolNum),
      );
      if (response.status !== 200) {
        setShowResultModal(!showResultModal);
        setRegistrationResult("error");
      } else {
        const data = await response.json();

        if (data.trainingCheckDataTotal.examType === 1) {
          setOptionsKnoweledgeTestRecord(true, columnsKnoweledgeTestRecordTable.ticketNum.accessor);
        }
        if (data.trainingCheckDataTotal.examType === 2) {
          setOptionsKnoweledgeTestRecord(false, columnsKnoweledgeTestRecordTable.ticketNum.accessor);
        }
        dispatch({
          type: SET_DATA_FOR_EDIT_KNOWELEDGE_TEST_RECORD,
          data: data,
        });
        setIsLoading(false);
      }
    }

    switch (mode) {
      case "add":
        setIsLoading(false);
        break;
      default:
        fetchData();
    }
  }, []);

  useEffect(() => {
    if (saveKey) {
      handleErrors();
    }
  }, [knowledgeTestRecordState]);
  if (isLoading) {
    return (
      <div className={"d-flex flex-column align-items-center"}>
        <ProgressBar
          height="80"
          width="80"
          ariaLabel="progress-bar-loading"
          wrapperStyle={{}}
          wrapperClass="progress-bar-wrapper"
          borderColor="#D2AF8E"
          barColor="#BC8653"
        />
      </div>
    );
  }
  return (
    <div className={styles["content-container"]}>
      <h2 className={styles["main-text"]}>Протокол проверки знаний</h2>
      <Form className={styles["form-container"]}>
        <div className={styles["grid-container"]}>
          {Object.values(optionsInputsKnoweledgeTestRecord).map((option) => {
            return (
              <>
                {option.fieldModeView ? (
                  <div className={`${styles["text-block"]} ${styles?.[`box-${option.key}`]}`}>
                    <p className={styles["option-label"]}>{option.label}</p>
                    <p className={styles["option-value"]}>
                      {option.type === "selectSearch"
                        ? option.options.find(
                            (elem) => elem.value === knowledgeTestRecordState.dataMain[option.key],
                          )?.label || "—"
                        : option.type === "date" && knowledgeTestRecordState.dataMain[option.key]
                        ? knowledgeTestRecordState.dataMain[option.key].split("-").reverse().join(".")
                        : knowledgeTestRecordState.dataMain[option.key] || "—"}
                    </p>
                  </div>
                ) : (
                  <Form.Group
                    controlId={`${option.key}`}
                    className={`${styles["common"]} ${styles[`box-${option.key}`]}`}>
                    <label className={styles["label"]}>
                      {option.label}
                      {option.required && mode !== "view" && <span className={styles.red_dot}>*</span>}
                    </label>
                    {option.type === "selectSearch" && (
                      <Select
                        noOptionsMessage={() => "Нет данных"}
                        id={option.key}
                        isSearchable={false}
                        isDisabled={
                          Boolean(knowledgeTestRecordState.dataForTable.length) &&
                          (option.key === "examType" || option.key === "programId")
                        }
                        placeholder={"Выберите"}
                        options={option.options}
                        onChange={(e) => updateInputData(e)}
                        value={option.options.find(
                          (item) => item.value === knowledgeTestRecordState.dataMain[option.key],
                        )}
                        styles={mode !== "view" && !!errors[option.key] ? customErrorStyles : customStyles}
                      />
                    )}
                    {option.type !== "selectSearch" && (
                      <input
                        className={`${styles["form-input"]} ${
                          errors[option.key] ? styles["red_border"] : ""
                        }`}
                        id={option.key}
                        onChange={(e) => updateInputData(e)}
                        type={option.type}
                        placeholder={"Введите"}
                        value={knowledgeTestRecordState.dataMain[option.key]}
                        readOnly={option.readOnly || mode === "view" || mode === "edit"}
                        disabled={mode === "view" || mode === "edit" || option.disabled ? true : false}
                        isInvalid={mode !== "view" && !!errors[option.key]}
                      />
                    )}
                  </Form.Group>
                )}
              </>
            );
          })}
        </div>
        {mode === "add" &&
          knowledgeTestRecordState.dataMain.examType &&
          knowledgeTestRecordState.dataMain.programId &&
          Boolean(knowledgeTestRecordState.dataMain.protDate) &&
          !dateError && (
            <button
              id={`add`}
              title={"Добавить слушателя"}
              className={styles["add-btn"]}
              onClick={(e) => handleButtonAddListener(e)}>
              <span className={styles["plus-icon"]}></span>
              <p className={styles["buttons-text"]}>Добавить слушателя</p>
            </button>
          )}
        {dateError && (
          <p className={styles["error-text"]}>
            <span className={styles.red_dot}>*</span> {dateError}
          </p>
        )}
        <EditableTableForKnoweledgeTest
          mode={mode}
          columns={Object.values(columnsKnoweledgeTestRecordTable).filter((column) => column.show)}
          handleTableDataUpdate={handleTableDataUpdate}
          tableData={knowledgeTestRecordState.dataForTable}
          caption={"Список слушателей"}
        />
      </Form>

      <div className={styles["buttons-block"]}>
        <div
          className={styles["close-btn"]}
          onClick={() => {
            handleCloseApp();
          }}>
          Закрыть
        </div>
        {mode !== "view" && Boolean(knowledgeTestRecordState.dataForTable.length) && (
          <div
            className={styles["save-btn"]}
            onClick={(e) => handleSave()}>
            {mode === "add" ? "Сохранить" : "Сохранить изменения"}
          </div>
        )}
        {(mode === "view" || mode === "edit") &&
          additionalAccess.printAccess &&
          knowledgeTestRecordState.dataMain.examType === 2 && (
            <div
              className={styles["save-btn"]}
              onClick={(e) => handlePrint()}>
              {"Печать"}
            </div>
          )}
      </div>
      {showResultModal && (
        <ResultModalWindow
          appId={appId}
          show={showResultModal}
          setShow={setShowResultModal}
          result={registrationResult}
          handleCloseApp={handleCloseApp}
        />
      )}
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        setShow={setShowNotificationWindow}
        headerText={"Уведомление"}
        messageText={messageNotificationWindow}
      />
    </div>
  );
}

export default CardKnowledgeTestRecord;
